import { render, staticRenderFns } from "./DueDiligenceReportTable.vue?vue&type=template&id=180c447f&scoped=true"
import script from "./DueDiligenceReportTable.vue?vue&type=script&lang=js"
export * from "./DueDiligenceReportTable.vue?vue&type=script&lang=js"
import style0 from "./DueDiligenceReportTable.vue?vue&type=style&index=0&id=180c447f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180c447f",
  null
  
)

export default component.exports